<app-vvr-icon [full]="false" [dark]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Inspectielijst @if (form()) {
                <span class="d-none d-md-inline">invullen</span>
            }</h1>
        </div>
        <div class="controls">
            @if (completed()?.id) {
                <div
                    (click)="pdf()" [class.disabled]="downloadingPdf()"
                    class="fab small"
                    id="btn-Pdf"
                    matTooltip="Download als PDF"
                    matTooltipPosition="below">
                    @if (!downloadingPdf()) {
                        <i class="fas fa-file-pdf"></i>
                    } @else {
                        <i class="fas fa-spinner fa-spin"></i>
                    }
                </div>
            }

            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar overzicht"
                matTooltipPosition="below"
                routerLink="/{{Routenames.checklistFillIn}}">
                <i class="fas fa-sign-out-alt"></i>
            </div>

        </div>
    </div>
    @if (form()) {
        <div class="checklist-form">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-9">
                    <div>
                        <h4 class="h4 condensed">
                            Algemene gegevens
                        </h4>
                    </div>
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Werknummer</mat-label>
                        <input [formControl]="form().controls.worknumber" matInput placeholder="Werknummer" type="text">
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Werkomschrijving</mat-label>
                        <input [formControl]="form().controls.description" matInput placeholder="Werkomschrijving" type="text">
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Adres / locatie</mat-label>
                        <input [formControl]="form().controls.location" matInput placeholder="Adres / locatie" type="text">
                    </mat-form-field>
                    <div class="row">
                        <ng-select
                            [formControl]="form().controls.foreman_id"
                            [items]="foremanList()"
                            appearance="outline"
                            bindLabel="name"
                            bindValue="id"
                            class="col-md-6"
                            placeholder="Voorman">
                        </ng-select>
                        <ng-select
                            [formControl]="form().controls.inspector_id"
                            [items]="inspectorList()"
                            appearance="outline"
                            bindLabel="name"
                            bindValue="id"
                            class="col-md-6"
                            placeholder="Inspecteur">
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12">
                    <div class="mt-3">
                        <h4 class="h4 condensed">
                            Inspectielijst
                        </h4>
                    </div>
                    <table>
                        <tr class="header">
                            <th>
                                Nr.
                            </th>
                            <th>
                                Vraag
                            </th>
                            <th>
                                Antwoord
                            </th>
                            <th>
                                Toelichting
                            </th>
                        </tr>
                        @for (question of checklist()?.questions; track question) {
                            <tr>
                                <th class="number">
                                    {{question.number}}
                                </th>
                                <th [innerHTML]="question.question | nl2br" colspan="5">
                                </th>
                            </tr>
                            @for (subQuestion of question.sub_items; track subQuestion) {
                                <tr class="sub-question">
                                    <td class="number">
                                        {{subQuestion.number}}
                                    </td>
                                    <td [innerHTML]="subQuestion.question | safeHtml" class="question">
                                    </td>
                                    <td class="answer">
                                        <mat-radio-group [formControl]="questionFormMap.get(subQuestion).answer" aria-label="{{subQuestion.question}}">
                                            <mat-radio-button [value]="AnswerOption.nvt">{{AnswerOption.nvt}}</mat-radio-button>
                                            <mat-radio-button [value]="AnswerOption.Nee">{{AnswerOption.Nee}}</mat-radio-button>
                                            <mat-radio-button [value]="AnswerOption.Ja">{{AnswerOption.Ja}}</mat-radio-button>
                                        </mat-radio-group>
                                    </td>
                                    <td class="comment">
                                        <mat-form-field appearance="fill" class="w-100">
                                            <mat-label>Toelichting</mat-label>
                                            <textarea
                                                [formControl]="questionFormMap.get(subQuestion).comment"
                                                cdkAutosizeMinRows="1"
                                                cdkTextareaAutosize
                                                matInput
                                                placeholder="Toelichting"
                                                type="text">
                                            </textarea>
                                        </mat-form-field>
                                    </td>
                                </tr>
                            }
                        }
                    </table>
                    <div class="mt-5">
                        <h4 class="h4 condensed">
                            Algehele indruk
                        </h4>
                    </div>
                    <table>
                        <tr class="header">
                            <th>
                                Positief/Leer punt
                            </th>
                            <th>
                                Beschrijving
                            </th>
                            <th class="delete">
                            </th>
                        </tr>
                        @for (point of form().controls.points.controls; track point; let i = $index) {
                            <tr class="point">
                                <td class="type">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Positief/Leer punt</mat-label>
                                        <mat-select [formControl]="point.controls.answer" placeholder="Positief/Leer punt">
                                            <mat-option [value]="ChecklistPointType.learn">
                                                Leerpunt
                                            </mat-option>
                                            <mat-option [value]="ChecklistPointType.learn">
                                                Positief punt
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                                <td class="comment">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Beschrijving</mat-label>
                                        <textarea
                                            [formControl]="point.controls.comment"
                                            cdkAutosizeMaxRows="5"
                                            cdkAutosizeMinRows="1"
                                            cdkTextareaAutosize
                                            matInput
                                            placeholder="Beschrijving">
                                        </textarea>
                                    </mat-form-field>
                                </td>
                                <td class="delete">
                                    <button
                                        (click)="deletePoint(i)"
                                        color="warn"
                                        mat-icon-button>
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        }
                        <tr>
                            <td colspan="2">
                                <button (click)="addPoint()" class="w-100" mat-button>
                                    Punt toevoegen
                                </button>
                            </td>
                        </tr>
                    </table>
                    <div class="mt-5">
                        <h4 class="h4 condensed">
                            Actielijst
                        </h4>
                    </div>
                    <table>
                        <tr class="header">
                            <th>
                                Nr.
                            </th>
                            <th>
                                Actiepunt
                            </th>
                            <th>
                                Door
                            </th>
                            <th>
                                Deadline
                            </th>
                            <th class="delete">
                            </th>
                        </tr>
                        @for (action of form().controls.actions.controls; track action; let i = $index) {
                            <tr class="action">
                                <td class="number-inp">
                                    <mat-form-field appearance="fill">
                                        <mat-label>
                                            Nr
                                        </mat-label>
                                        <mat-select [formControl]="action.controls.question_id">
                                            <mat-select-trigger>
                                                <b class="text-uppercase">{{questions.get(action.value.question_id)?.number}}</b>
                                            </mat-select-trigger>
                                            @for (question of checklist().questions; track question) {
                                                <mat-optgroup label="{{question.number}} {{question.question}}">
                                                    @for (subQuestion of question.sub_items; track subQuestion) {
                                                        <mat-option
                                                            [value]="subQuestion.id">
                                                            <b class="text-uppercase">{{subQuestion.number}} </b>{{subQuestion.question}}
                                                        </mat-option>
                                                    }
                                                </mat-optgroup>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                                <td class="action">
                                    <mat-form-field appearance="fill">
                                        <mat-label>
                                            Actie
                                        </mat-label>
                                        <textarea
                                            [formControl]="action.controls.action"
                                            cdkAutosizeMinRows="1"
                                            cdkTextareaAutosize
                                            matInput
                                            placeholder="Actie">
                                        </textarea>
                                    </mat-form-field>
                                </td>
                                <td class="user">
                                    <mat-form-field appearance="fill">
                                        <mat-label>
                                            Door
                                        </mat-label>
                                        <input
                                            [formControl]="action.controls.user"
                                            matInput
                                            placeholder="Door"
                                            type="text">
                                    </mat-form-field>
                                </td>
                                <td class="deadline">
                                    <mat-form-field appearance="fill" class="w-100">
                                        <mat-label>
                                            Deadline
                                        </mat-label>
                                        <input
                                            (focusin)="picker.open()"
                                            [formControl]="action.controls.deadline"
                                            [matDatepicker]="picker"
                                            matInput
                                            placeholder="Deadline">
                                        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </td>
                                <td class="delete">
                                    <button
                                        (click)="deleteAction(i)"
                                        color="warn"
                                        mat-icon-button>
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        }
                        <tr>
                            <td colspan="4">
                                <button (click)="addAction()" class="w-100" mat-button>
                                    Actie toevoegen
                                </button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="row justify-content-center mt-3 pb-3">
                <div class="col-12">
                    <div class="d-flex">
                        <button mat-button routerLink="/{{Routenames.checklistFillIn}}">Terug</button>
                        <div class="spacer"></div>
                        <div class="d-flex align-items-center">
                            <mat-checkbox [formControl]="form().controls.final" class="pe-3" color="primary">
                                Maak deze inspectielijst definitief
                            </mat-checkbox>
                            <button (click)="save()" color="primary" id="btn-save" mat-raised-button>
                                Opslaan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    } @else if (!form() && completed()?.final) {
        <div class="pb-5">
            <table class="mb-5">
                <tr>
                    <th>
                        Checklist
                    </th>
                    <td class="ps-2">
                        {{checklist()?.name}}
                    </td>
                </tr>
                <tr>
                    <th>
                        Checklist nummer
                    </th>
                    <td class="ps-2">
                        {{checklist()?.number}}
                    </td>
                </tr>
                <tr>
                    <th>
                        Checklist versie
                    </th>
                    <td class="ps-2">
                        {{checklist()?.version}}
                    </td>
                </tr>
                <tr>
                    <th>
                        Beheert door
                    </th>
                    <td class="ps-2">
                        {{checklist()?.managed_by}}
                    </td>
                </tr>
                <tr>
                    <th>
                        Datum
                    </th>
                    <td class="ps-2">
                        {{checklist()?.updated_at | date : 'd MMMM yyyy'}}
                    </td>
                </tr>
            </table>
            <app-checklist-pdf [completed]="completed()"></app-checklist-pdf>
        </div>
    }
</div>
